// extracted by mini-css-extract-plugin
module.exports = {"tier_medal":"LoyaltyTierMedal_tier_medal__eBcbo"};